var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAdminPropertyFailed = function SvgAdminPropertyFailed(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#D52331"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M37.195 34l8.143-8.143c.883-.882.883-2.313 0-3.195-.882-.883-2.313-.883-3.195 0L34 30.805l-8.143-8.143c-.882-.883-2.313-.883-3.195 0-.883.882-.883 2.313 0 3.195L30.805 34l-8.143 8.143c-.883.882-.883 2.313 0 3.195.882.883 2.313.883 3.195 0L34 37.195l8.143 8.143c.882.883 2.313.883 3.195 0 .883-.882.883-2.313 0-3.195L37.195 34z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAdminPropertyFailed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/admin-property-failed.98162345bac633558bc8cefb4fc4bfc5.svg";